import OfertaPublic from './oferta-public.vue';

var routes = [{
        path: '/public/oferta/',
        component: OfertaPublic
    }
];
export default routes;